import { ChangeEmailDto } from "./dto/change-email.dto";
import { ChangePasswordDto } from "./dto/change-password.dto";
import { createUseApi } from "./useApi";
import { UserSupportRequestDto } from "~/api/dto/user-support-request.dto.ts";

const config = useRuntimeConfig();
export const users = {
  useChangeOwnPassword: createUseApi<ChangePasswordDto, void>({
    requireAuthentication: true,
    method: "PATCH",
    url: `${config.public.url}/user/current/password`,
    dataBuilder: (inputData) => inputData,
  }),
  useChangeOwnEmail: createUseApi<ChangeEmailDto, void>({
    requireAuthentication: true,
    method: "PATCH",
    url: `${config.public.url}/user/current/email`,
    dataBuilder: (inputData) => inputData,
  }),
  useVerifyEmail: createUseApi<string, void>({
    method: "POST",
    url: `${config.public.url}/email-verification/verify`,
    dataBuilder: (secret: string) => ({ secret }),
  }),
  sendSupportRequest: createUseApi<UserSupportRequestDto, void>({
    requireAuthentication: true,
    method: "POST",
    url: `${config.public.url}/user/current/support`,
    dataBuilder: (inputData) => inputData,
  }),
};
